var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('atom-label',{attrs:{"light":"","small":"","text":"All customers"}}),_vm._v(" "),_c('molecule-list',{attrs:{"items":_vm.customers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }